"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WhatsAppSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M2.09 30l2-7.18a13.85 13.85 0 1112 6.94 13.81 13.81 0 01-6.62-1.69zm7.68-4.44l.42.25a11.53 11.53 0 005.86 1.61A11.52 11.52 0 106.3 22l.28.44-1.17 4.25z"/><path d="M12.59 10.09c-.28-.68-.56-.59-.77-.6h-.67a1.29 1.29 0 00-.92.43A3.89 3.89 0 009 12.8a6.69 6.69 0 001.41 3.58 15.41 15.41 0 005.91 5.23 20.39 20.39 0 002 .72 4.6 4.6 0 002.18.14 3.55 3.55 0 002.33-1.64 2.92 2.92 0 00.17-1.65c-.09-.14-.32-.23-.67-.4s-2.05-1-2.36-1.13-.55-.17-.78.17-.9 1.13-1.1 1.36-.4.26-.75.09a9.51 9.51 0 01-2.78-1.72 10.39 10.39 0 01-1.93-2.4c-.2-.34 0-.53.15-.7l.52-.61a2.3 2.3 0 00.35-.58.64.64 0 000-.6l-1.06-2.57z"/>';
var WhatsAppSVG = function WhatsAppSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.WhatsAppSVG = WhatsAppSVG;
WhatsAppSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(WhatsAppSVG);
exports.default = _default;